import { render, staticRenderFns } from "./CsvDropArea.vue?vue&type=template&id=496ec32c&"
import script from "./CsvDropArea.vue?vue&type=script&lang=js&"
export * from "./CsvDropArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports